export interface ISupportEmailProps {
  supportTicketId: string
  supportSubmissionTime: string
  supportCategory: string
  supportDescription: string
  fullName: string
  accountType?: string
  email: string
}

export type ISupportEmailRequest = Pick<
  ISupportEmailProps,
  'supportCategory' | 'supportDescription'
>

export const SupportEmailCategories = [
  { key: '', value: 'general.forms.chooseOption' },
  { key: 'question', value: 'email.labelQuestion' },
  { key: 'technical', value: 'email.labelTechnical' },
  { key: 'feature', value: 'email.labelFeature' },
  { key: 'hello', value: 'email.labelHello' },
  { key: 'else', value: 'email.labelElse' },
]
